import ZContainer from '@/ZForms/parsers/entities/ZEntityContainer';


class ChartData {
  constructor(rawChart) {
    this.lines = rawChart.lines == null ? [] : rawChart.lines;
    this.chartType = rawChart.chart_type == null ? 'histogram' : rawChart.chart_type;
    this.drawMode = rawChart.draw_mode == null ? 'accumulate' : rawChart.draw_mode;
    this.chartRuler = rawChart.chart_ruler == null ? 'main' : rawChart.chart_ruler;
  }
}


export default window.ZForms.registerClass('container.form.hybrid_chart', class ZHybridChartForm extends ZContainer {
  constructor() {
    super(...arguments);
    this.orientation = 'vertical';
    this.dataDimensionField = null;
    this.rowsDimensionIdx = null;
    this.columnDimensionIdx = null;
    this.seDimensionIdx = null;
    this.endDimValKey = null;
    this.startDimValKey = null;
    this.chartList = [];
  }

  async _updateMetaFromRaw(rawData) {
    await super._updateMetaFromRaw(rawData);
    if (rawData.chart_settings == null) {
      return;
    }

    this.orientation = (
      rawData.chart_settings.orientation != null ?
      rawData.chart_settings.orientation :
      this.orientation
    );

    this.dataDimensionField = (
        rawData.chart_settings.data_dimension_field != null ?
        this.contentMeta.fields[rawData.chart_settings.data_dimension_field] :
        this.dataDimensionField
    );

    this.rowsDimensionIdx = (
        rawData.chart_settings.rows_dimension_idx != null ?
        rawData.chart_settings.rows_dimension_idx :
        this.rowsDimensionIdx
    );

    this.columnDimensionIdx = (
      rawData.chart_settings.column_dimension_idx != null ?
      rawData.chart_settings.column_dimension_idx :
      this.columnDimensionIdx
    );

    this.seDimensionIdx = (
      rawData.chart_settings.se_dimension_idx != null ?
      rawData.chart_settings.se_dimension_idx :
      this.seDimensionIdx
    );

    const dimIndexes = [0, 1, 2].filter((cVal) => ![
      this.rowsDimensionIdx,
      this.columnDimensionIdx,
      this.seDimensionIdx,
    ].includes(cVal));
    this.rowsDimensionIdx = this.rowsDimensionIdx == null ? dimIndexes.splice(0, 1)[0] : this.rowsDimensionIdx;
    this.columnDimensionIdx = this.columnDimensionIdx == null ? dimIndexes.splice(0, 1)[0] : this.columnDimensionIdx;
    this.seDimensionIdx = this.seDimensionIdx == null ? dimIndexes.splice(0, 1)[0] : this.seDimensionIdx;

    this.endDimValKey = rawData.end_dim_val_key != null ? rawData.end_dim_val_key : this.endDimValKey;
    this.startDimValKey = rawData.start_dim_val_key != null ? rawData.start_dim_val_key : this.startDimValKey;

    if (this.dataDimensionField != null && this.dataDimensionField.dimensions[this.seDimensionIdx] != null) {
      const vals = Object.keys(this.dataDimensionField.dimensions[this.seDimensionIdx].values).filter((cVal) => ![
        this.startDimValKey,
        this.endDimValKey,
      ].includes(cVal));

      if (this.startDimValKey == null) {
        this.startDimValKey = vals.splice(0, 1)[0];
      }
      if (this.endDimValKey == null) {
        this.endDimValKey = vals.splice(0, 1)[0];
      }
    }

    if (this.endDimValKey == null) this.endDimValKey = 'e';
    if (this.startDimValKey == null) this.startDimValKey = 's';

    this.chartList = (
      rawData.chart_settings.chart_groups != null ?
      rawData.chart_settings.chart_groups.map((rawChart) => new ChartData(rawChart)) :
      this.chartList
    );

    const emptyLineCharts = this.chartList.filter((chart) => chart.lines.length < 1);

    if (emptyLineCharts.length > 0) {
      const usedChartRows = this.chartList.map((chart) => chart.lines).flat();
      const notUsedChartRows = Object.keys(this.dataDimensionField.dimensions[this.rowsDimensionIdx].values).filter((rowKey) => !usedChartRows.includes(rowKey));

      let bigCounter = 0;
      let curCounter = 0;
      let curChartId = 0;
      const forChartLines = Math.ceil(notUsedChartRows.length / emptyLineCharts.length);
      while (bigCounter < notUsedChartRows.length && curChartId < emptyLineCharts.length) {
        if (curCounter >= forChartLines) {
          curCounter = 0;
          curChartId += 1;
        }

        emptyLineCharts[curChartId].lines.push(notUsedChartRows[bigCounter]);

        bigCounter += 1;
      }
    }
  }
});
